'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bookAppointmentModal = require('../../src/styles/book-appointment-modal.scss');

var _bookAppointmentModal2 = _interopRequireDefault(_bookAppointmentModal);

require('../../src/styles/external.scss');

var _doctifyModal = require('./doctify-modal');

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

var _loginComponent = require('login-component');

var _bookAppointment = require('../../../book-appointment');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { FormattedMessage } from 'react-intl';

var getBookAppointment = function getBookAppointment(props) {
	return _react2.default.createElement(_bookAppointment.BookAppointment, {
		specialistName: props.specialistName,
		practiceName: props.practiceName,
		appointmentDatetime: props.appointmentDatetime,
		insurers: props.insurers,
		requestData: props.requestData,
		onPhoneChange: props.onPhoneChange,
		onClaimNumberChange: props.onClaimNumberChange,
		onPolicyNumberChange: props.onPolicyNumberChange,
		onVisitedOptionSelected: props.onVisitedOptionSelected,
		onInsuranceSelected: props.onInsuranceSelected,
		onVisitReasonChange: props.onVisitReasonChange,
		submitAppointmentRequest: props.submitAppointmentRequest,
		submitAttempted: props.submitAttempted,
		submitSuccessful: props.submitSuccessful,
		submitFailed: props.submitFailed,
		setValidPhone: props.setValidPhone,
		setValidClaimNumber: props.setValidClaimNumber,
		setValidPolicyNumber: props.setValidPolicyNumber,
		validPhone: props.validPhone,
		validClaimNumber: props.validClaimNumber,
		validPolicyNumber: props.validPolicyNumber,
		validInsurer: props.validInsurer,
		validationError: props.validationError,
		validVisitedOption: props.validVisitedOption,
		onCancel: props.closeModal
	});
};
// import messages from '../lang/default-messages';

getBookAppointment.propTypes = {
	account: require('react').PropTypes.object.isRequired,
	requestData: require('react').PropTypes.object.isRequired,
	specialistName: require('react').PropTypes.any.isRequired,
	practiceName: require('react').PropTypes.any.isRequired,
	appointmentDatetime: require('react').PropTypes.any.isRequired,
	insurers: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
		id: require('react').PropTypes.any.isRequired,
		name: require('react').PropTypes.any.isRequired
	})).isRequired,
	className: require('react').PropTypes.any,
	submitAttempted: require('react').PropTypes.any.isRequired,
	submitSuccessful: require('react').PropTypes.any.isRequired,
	submitFailed: require('react').PropTypes.any.isRequired,
	validPhone: require('react').PropTypes.any.isRequired,
	validPolicyNumber: require('react').PropTypes.any.isRequired,
	validClaimNumber: require('react').PropTypes.any.isRequired,
	validInsurer: require('react').PropTypes.any.isRequired,
	validVisitedOption: require('react').PropTypes.any.isRequired,
	modalDisplayPage: require('react').PropTypes.any.isRequired,
	showLogin: require('react').PropTypes.func.isRequired,
	showSignUp: require('react').PropTypes.func.isRequired,
	closeModal: require('react').PropTypes.func.isRequired,
	onPhoneChange: require('react').PropTypes.func.isRequired,
	onPolicyNumberChange: require('react').PropTypes.func.isRequired,
	onClaimNumberChange: require('react').PropTypes.func.isRequired,
	onVisitedOptionSelected: require('react').PropTypes.func.isRequired,
	onInsuranceSelected: require('react').PropTypes.func.isRequired,
	onVisitReasonChange: require('react').PropTypes.func.isRequired,
	submitAppointmentRequest: require('react').PropTypes.func.isRequired,
	validationError: require('react').PropTypes.func.isRequired,
	setValidPhone: require('react').PropTypes.func.isRequired,
	setValidPolicyNumber: require('react').PropTypes.func.isRequired,
	setValidClaimNumber: require('react').PropTypes.func.isRequired,
	login: require('react').PropTypes.shape({
		error: require('react').PropTypes.any.isRequired,
		email: require('react').PropTypes.any,
		rememberMe: require('react').PropTypes.any.isRequired,
		validEmail: require('react').PropTypes.any.isRequired,
		validInsurer: require('react').PropTypes.any.isRequired,
		validVisitedOption: require('react').PropTypes.any.isRequired,
		submitAttempted: require('react').PropTypes.any.isRequired,
		submitFailed: require('react').PropTypes.any.isRequired
	}).isRequired,
	loginUpdateEmail: require('react').PropTypes.func.isRequired,
	loginRememberMeChecked: require('react').PropTypes.func.isRequired,
	loginOnSubmit: require('react').PropTypes.func.isRequired,
	loginSetValidEmail: require('react').PropTypes.func.isRequired,
	loginValidationError: require('react').PropTypes.func.isRequired,
	bookingFlowAuthInfo: require('react').PropTypes.object
};


var getBookingConfirmation = function getBookingConfirmation(props) {
	return _react2.default.createElement(_bookAppointment.BookingConfirmation, {
		specialistName: props.specialistName,
		practiceName: props.practiceName,
		appointmentDatetime: props.appointmentDatetime,
		onClose: props.closeModal
	});
};

// I'm not sure there's much point in these 2 functions - they could be constructed with
// { ...props }, which is essentially an unnecessary level of abstraction. Suggest we
// just put the jsx in the BookAppointmentModal function below.

getBookingConfirmation.propTypes = {
	account: require('react').PropTypes.object.isRequired,
	requestData: require('react').PropTypes.object.isRequired,
	specialistName: require('react').PropTypes.any.isRequired,
	practiceName: require('react').PropTypes.any.isRequired,
	appointmentDatetime: require('react').PropTypes.any.isRequired,
	insurers: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
		id: require('react').PropTypes.any.isRequired,
		name: require('react').PropTypes.any.isRequired
	})).isRequired,
	className: require('react').PropTypes.any,
	submitAttempted: require('react').PropTypes.any.isRequired,
	submitSuccessful: require('react').PropTypes.any.isRequired,
	submitFailed: require('react').PropTypes.any.isRequired,
	validPhone: require('react').PropTypes.any.isRequired,
	validPolicyNumber: require('react').PropTypes.any.isRequired,
	validClaimNumber: require('react').PropTypes.any.isRequired,
	validInsurer: require('react').PropTypes.any.isRequired,
	validVisitedOption: require('react').PropTypes.any.isRequired,
	modalDisplayPage: require('react').PropTypes.any.isRequired,
	showLogin: require('react').PropTypes.func.isRequired,
	showSignUp: require('react').PropTypes.func.isRequired,
	closeModal: require('react').PropTypes.func.isRequired,
	onPhoneChange: require('react').PropTypes.func.isRequired,
	onPolicyNumberChange: require('react').PropTypes.func.isRequired,
	onClaimNumberChange: require('react').PropTypes.func.isRequired,
	onVisitedOptionSelected: require('react').PropTypes.func.isRequired,
	onInsuranceSelected: require('react').PropTypes.func.isRequired,
	onVisitReasonChange: require('react').PropTypes.func.isRequired,
	submitAppointmentRequest: require('react').PropTypes.func.isRequired,
	validationError: require('react').PropTypes.func.isRequired,
	setValidPhone: require('react').PropTypes.func.isRequired,
	setValidPolicyNumber: require('react').PropTypes.func.isRequired,
	setValidClaimNumber: require('react').PropTypes.func.isRequired,
	login: require('react').PropTypes.shape({
		error: require('react').PropTypes.any.isRequired,
		email: require('react').PropTypes.any,
		rememberMe: require('react').PropTypes.any.isRequired,
		validEmail: require('react').PropTypes.any.isRequired,
		validInsurer: require('react').PropTypes.any.isRequired,
		validVisitedOption: require('react').PropTypes.any.isRequired,
		submitAttempted: require('react').PropTypes.any.isRequired,
		submitFailed: require('react').PropTypes.any.isRequired
	}).isRequired,
	loginUpdateEmail: require('react').PropTypes.func.isRequired,
	loginRememberMeChecked: require('react').PropTypes.func.isRequired,
	loginOnSubmit: require('react').PropTypes.func.isRequired,
	loginSetValidEmail: require('react').PropTypes.func.isRequired,
	loginValidationError: require('react').PropTypes.func.isRequired,
	bookingFlowAuthInfo: require('react').PropTypes.object
};
var BookAppointmentModal = function BookAppointmentModal(props) {
	return _react2.default.createElement(
		_doctifyModal2.default,
		(0, _extends3.default)({}, props, {
			className: _bookAppointmentModal2.default.modalContainer + ' ' + props.className,
			bodyStyles: _bookAppointmentModal2.default.body,
			header: !props.submitSuccessful ? _react2.default.createElement(
				'span',
				null,
				'Book appointment ',
				_react2.default.createElement(
					'span',
					{ className: _bookAppointmentModal2.default.headerSmall + ' ' + _bookAppointmentModal2.default.green },
					'- in less than 60 seconds'
				)
			) : _react2.default.createElement(
				'span',
				{ className: _bookAppointmentModal2.default.headerLarge + ' ' + _bookAppointmentModal2.default.green },
				_react2.default.createElement('i', { className: 'ion-ios-checkmark-outline' }),
				'Thanks'
			) }),
		// Next conditional render === janky hack for the book appt flow. See also global redux, specialist page, and sign up modal.
		(props.account.patient && props.account.patient.email || props.bookingFlowAuthInfo && props.bookingFlowAuthInfo.email) && _react2.default.createElement(
			'div',
			null,
			props.submitSuccessful ? getBookingConfirmation(props) : getBookAppointment(props)
		) || _react2.default.createElement(
			'div',
			null,
			props.account.specialist && props.account.specialist.account && props.account.specialist.account.id && _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'p',
					{ className: _bookAppointmentModal2.default.loginMessage },
					'You\'re logged in as a Specialist. You must log in as a patient to book an appointment.'
				),
				_react2.default.createElement(
					'button',
					{ className: 'btn solid specialist col-sm-12',
						type: 'button',
						onClick: function onClick() {
							props.closeModal();
						} },
					'Close'
				)
			) || _react2.default.createElement(
				'div',
				null,
				props.modalDisplayPage === 'loginOrSignUp' && _react2.default.createElement(
					'div',
					{ className: _bookAppointmentModal2.default.authentication },
					_react2.default.createElement(
						'div',
						{ className: _bookAppointmentModal2.default.details },
						'Please login or sign up before you book an appointment.'
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 col-md-6' },
						_react2.default.createElement(
							'a',
							{ className: 'btn solid',
								onClick: function onClick() {
									props.showLogin();
									(0, _doctifyUtils.fireGTMevent)('patient_booking_login_step4');
								} },
							'Login'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12 col-md-6' },
						_react2.default.createElement(
							'a',
							{ className: 'btn solid',
								onClick: function onClick() {
									props.showSignUp();
									(0, _doctifyUtils.fireGTMevent)('patient_booking_create_step4');
								} },
							'Sign up'
						)
					)
				),
				props.modalDisplayPage === 'login' && _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_loginComponent.LoginComponent, {
						error: props.login.error,
						email: props.login.email,
						rememberMe: props.login.rememberMe,
						rememberMeChecked: props.rememberMeChecked,
						validEmail: props.login.validEmail,
						submitAttempted: props.login.submitAttempted,
						submitFailed: props.login.submitFailed,
						updateEmail: props.loginUpdateEmail,
						login: props.loginOnSubmit,
						setValidEmail: props.loginSetValidEmail,
						errorMessage: props.login.errorMessage,
						validationError: props.loginValidationFailed })
				)
			)
		)
	);
};

BookAppointmentModal.propTypes = {
	account: require('react').PropTypes.object.isRequired,
	requestData: require('react').PropTypes.object.isRequired,
	specialistName: require('react').PropTypes.any.isRequired,
	practiceName: require('react').PropTypes.any.isRequired,
	appointmentDatetime: require('react').PropTypes.any.isRequired,
	insurers: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
		id: require('react').PropTypes.any.isRequired,
		name: require('react').PropTypes.any.isRequired
	})).isRequired,
	className: require('react').PropTypes.any,
	submitAttempted: require('react').PropTypes.any.isRequired,
	submitSuccessful: require('react').PropTypes.any.isRequired,
	submitFailed: require('react').PropTypes.any.isRequired,
	validPhone: require('react').PropTypes.any.isRequired,
	validPolicyNumber: require('react').PropTypes.any.isRequired,
	validClaimNumber: require('react').PropTypes.any.isRequired,
	validInsurer: require('react').PropTypes.any.isRequired,
	validVisitedOption: require('react').PropTypes.any.isRequired,
	modalDisplayPage: require('react').PropTypes.any.isRequired,
	showLogin: require('react').PropTypes.func.isRequired,
	showSignUp: require('react').PropTypes.func.isRequired,
	closeModal: require('react').PropTypes.func.isRequired,
	onPhoneChange: require('react').PropTypes.func.isRequired,
	onPolicyNumberChange: require('react').PropTypes.func.isRequired,
	onClaimNumberChange: require('react').PropTypes.func.isRequired,
	onVisitedOptionSelected: require('react').PropTypes.func.isRequired,
	onInsuranceSelected: require('react').PropTypes.func.isRequired,
	onVisitReasonChange: require('react').PropTypes.func.isRequired,
	submitAppointmentRequest: require('react').PropTypes.func.isRequired,
	validationError: require('react').PropTypes.func.isRequired,
	setValidPhone: require('react').PropTypes.func.isRequired,
	setValidPolicyNumber: require('react').PropTypes.func.isRequired,
	setValidClaimNumber: require('react').PropTypes.func.isRequired,
	login: require('react').PropTypes.shape({
		error: require('react').PropTypes.any.isRequired,
		email: require('react').PropTypes.any,
		rememberMe: require('react').PropTypes.any.isRequired,
		validEmail: require('react').PropTypes.any.isRequired,
		validInsurer: require('react').PropTypes.any.isRequired,
		validVisitedOption: require('react').PropTypes.any.isRequired,
		submitAttempted: require('react').PropTypes.any.isRequired,
		submitFailed: require('react').PropTypes.any.isRequired
	}).isRequired,
	loginUpdateEmail: require('react').PropTypes.func.isRequired,
	loginRememberMeChecked: require('react').PropTypes.func.isRequired,
	loginOnSubmit: require('react').PropTypes.func.isRequired,
	loginSetValidEmail: require('react').PropTypes.func.isRequired,
	loginValidationError: require('react').PropTypes.func.isRequired,
	bookingFlowAuthInfo: require('react').PropTypes.object
};
BookAppointmentModal.displayName = 'BookAppointmentModal';

BookAppointmentModal.defaultProps = {
	account: {},
	insurers: []
};

exports.default = BookAppointmentModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/book-appointment-modal.js